import script from "./PartnersSection.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnersSection.vue?vue&type=script&setup=true&lang=js"

import "./PartnersSection.vue?vue&type=style&index=0&id=fcc97cc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fcc97cc2"]])

export default __exports__